module.exports = __webpack_public_path__ + "Lato-BlackItalic.a8642cee117dd62f5e48.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-BlackItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-BlackItalic.eot
// module chunks = styles